/**
 * RBC tracking event constants
 * RBC-specific complete buy events for products without dedicated constants in libs
 * These should eventually be added to libs/types if they become standard
 */

import type {
  COMPLETE_BUY_AIR,
  COMPLETE_BUY_CARS,
  LodgingCheckoutTrackingEvents,
  SELECT_REWARDS,
  VIEW_PAYMENT,
  CHOOSE_PAYMENT,
  REVIEW_DETAILS,
  ADD_CONTACT_INFO,
  SELECT_TRAVELERS,
  ADD_PAYMENT,
  SELECT_PAYMENT,
  VIEWED_CONTACT_INFO,
  VIEWED_PAYMENT_PAGE,
} from "@hopper-b2b/types";

export const COMPLETE_BUY_PACKAGE = "complete_buy_package" as const;
export const COMPLETE_BUY_ACTIVITY = "complete_buy_activities" as const;
export const COMPLETE_BUY_HOME = "complete_buy_home" as const;

// Confirmation page view events
export const VIEWED_ACTIVITY_BOOKING_CONFIRMATION =
  "viewed_activity_booking_confirmation" as const;
export const VIEWED_PACKAGE_BOOKING_CONFIRMATION =
  "viewed_package_booking_confirmation" as const;

/**
 * All checkout event names (strongly typed)
 * Union of generic events from libs + RBC-specific events
 */
export type CheckoutEventName =
  | typeof SELECT_REWARDS
  | typeof VIEW_PAYMENT
  | typeof CHOOSE_PAYMENT
  | typeof REVIEW_DETAILS
  | typeof COMPLETE_BUY_AIR
  | typeof COMPLETE_BUY_CARS
  | typeof COMPLETE_BUY_PACKAGE
  | typeof COMPLETE_BUY_ACTIVITY
  | typeof COMPLETE_BUY_HOME
  | typeof ADD_CONTACT_INFO
  | typeof SELECT_TRAVELERS
  | typeof ADD_PAYMENT
  | typeof SELECT_PAYMENT
  | typeof VIEWED_CONTACT_INFO
  | typeof VIEWED_PAYMENT_PAGE
  | typeof VIEWED_ACTIVITY_BOOKING_CONFIRMATION
  | typeof VIEWED_PACKAGE_BOOKING_CONFIRMATION
  | LodgingCheckoutTrackingEvents;
